import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuChartNoAxesColumn, LuExternalLink } from 'react-icons/lu';
import { ehAnuncioPago, linkDoAnuncio, type AtribuicaoAnuncio } from '../services/TrafegoPagoService';
import { getUserPermissions, hasPermission, temFuncionalidade } from '../config/permissions';
import './AcoesDoAnuncio.css';

/**
 * Os botões do anúncio no cartão de Origem da oportunidade.
 * Desenho: docs/propostas/pipeline/ficha-e-anuncio.html.
 *
 * "Ver o reels" é para todo perfil e toda empresa: é a peça que a pessoa viu antes de
 * escrever, não custo. "Desempenho" só onde a tela de Anúncios existe — a funcionalidade
 * ligada para a empresa E a permissão do perfil: controle que leva a um 403 é pior do que
 * controle ausente. No Chat o anúncio aparece citado na mensagem (ConversationWindow), sem
 * "Desempenho": custo e retorno são assunto da ficha. Publicação e story também não levam a
 * "Desempenho": não têm gasto e a tela de Anúncios não os lista.
 */
const AcoesDoAnuncio: FC<{ atribuicao: AtribuicaoAnuncio }> = ({ atribuicao }) => {
    const navigate = useNavigate();
    const link = linkDoAnuncio(atribuicao);
    const podeVerAnuncios = ehAnuncioPago(atribuicao)
        && temFuncionalidade('anuncios') && hasPermission(getUserPermissions(), ['anuncios']);
    if (!link && !podeVerAnuncios) return null;

    return (
        <span className="anu-origem-acoes">
            {link && (
                <a className="anu-origem-btn" href={link.url} target="_blank" rel="noopener noreferrer">
                    <LuExternalLink size={13} />
                    {link.rotulo}
                </a>
            )}
            {/* Leva ao desempenho, na tela de Anúncios — por isso não se chama "Ver o anúncio". */}
            {podeVerAnuncios && (
                <button type="button" className="anu-origem-btn" onClick={() => navigate('/anuncios')}>
                    <LuChartNoAxesColumn size={13} />
                    Desempenho
                </button>
            )}
        </span>
    );
};

export default AcoesDoAnuncio;
